import { RootState } from '../store';

export const selectFechaDesde = (state: RootState) => state.fechaDesde.fecha;
